module.exports = __webpack_public_path__ + "img/mikalaj.m__600x600.c938af62.jpg";